import React, { Component } from 'react';
import PropTypes from "prop-types";
import "./ReportComment.css";
import { TextArea, Button, Intent } from "@blueprintjs/core";
import { withTranslation } from 'react-i18next';

import ReactModal from 'react-modal-resizable-draggable';

class ReportComment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reporter: "",
            comment: "",
            maxChart: 638,
            leftChart: 638,
            MaxLines: 11,
            lines: 11,
            lineExtension: 120,
            modalIsOpen: true,
            tooLong: false
        };

        //this.openModal = this.openModal.bind(this);
        //this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount = () => {
        const { reporter, comment, user } = this.props;
        //handleReporter(user.username);
        this.setState({ comment: comment, reporter: reporter, leftChart: this.state.maxChart - comment.length - 1 });
    }

    controlLineLength = (arrStr) => {
        let lineCorrect = true;
        arrStr.forEach(item => {
            if (item.length > this.state.lineExtension) {
                lineCorrect = false;
            }
        });
        return lineCorrect;
    }

    handleChange = (e) => {
        const { handleReportComment } = this.props;
        let currentComment = e.target.value;
        const commentAreaElement = document.getElementById("commentTextArea");

        if (commentAreaElement.clientHeight < commentAreaElement.scrollHeight) {
            if (currentComment.length > this.state.previousComment.length) {
                currentComment = this.state.previousComment;
            }
            this.setState({ tooLong: true });
        }
        else {
            this.setState({ previousComment: currentComment });
        }

        this.setState({
            comment: currentComment,
            leftChart: this.state.maxChart - e.target.value.length - 1,
            lines: currentComment.split(/\r\n|\r|\n/).length
        });
        handleReportComment(currentComment);
        this.setState({ tooLong: commentAreaElement.clientHeight < commentAreaElement.scrollHeight });
    }

    handleReporter = (e) => {
        const { handleReporter } = this.props;
        this.setState({ reporter: e.target.value });
        handleReporter(e.target.value);
    }

    //openModal() {
    //    this.setState({ modalIsOpen: true });
    //}

    //closeModal() {
    //    this.setState({ modalIsOpen: false });
    //}

    handlePrintReport = () => {
        const { handleReportPDF, closeModal } = this.props;
        handleReportPDF();
        closeModal();
    }

    render() {
        const {
            modalIsOpen,
            closeModal,
            t
        } = this.props;

        return (

            <ReactModal
                style={{ width: "1800px", height: "800px" }}
                onFocus={() => console.log("Modal is clicked")}
                className={"modalclass"}
                onRequestClose={closeModal}
                isOpen={modalIsOpen}
                disableKeystroke={"true"}
                disableResize={"true"}>
                <h3>{t("Report Comments")}</h3>
                <div className="content">
                    <div className="reporter">
                        <span> {t("Creator: ")} </span>
                        <input className="bp4-fill" type="text" placeholder="Reporter name" value={this.state.reporter} onChange={this.handleReporter} dir="auto" />
                    </div>
                    <TextArea className="textarea" id="commentTextArea"
                        onChange={this.handleChange}
                        rows={11}
                        value={this.state.comment}
                    />
                    <div> {this.state.tooLong ? <span className="error"> {t("Report comment too long")} </span> : ""} </div>
                    <div className="actionButtonDiv">
                        <Button className="actionButton" icon={"cross"} onClick={closeModal}> {t("Close")} </Button>
                        <Button className="actionButton" disabled={this.state.tooLong} icon={"print"} onClick={this.handlePrintReport}> {t("Print")}  </Button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(ReportComment)

ReportComment.propTypes = {

};
            